import { useCallback, useRef, useState } from 'react';

import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { FormHandles } from '@unform/core';

import { useNotices } from 'hooks';

import Modal from 'components/common/Modal';
import TextArea from 'components/common/Input/TextArea';

import { Evaluate } from './Evaluate';

import * as S from './styles';
import Input from 'components/common/Input';
import getValidationErrors from 'utils/getValidationErrors';
import { addProductReview, IProductPropsPDP } from 'store/modules/product';

interface IModalRatingProductProps {
  setShowModalRatingProduct(state: boolean): void;
  product: IProductPropsPDP;
}

export function ModalRatingProduct({
  setShowModalRatingProduct,
  product,
}: IModalRatingProductProps) {
  const dispatch = useDispatch();
  const { addNotices } = useNotices();

  const formRatingProduct = useRef<FormHandles>(null);

  const [stars, setStars] = useState(0);

  const handleRatingProduct = useCallback(
    async data => {
      try {
        formRatingProduct.current?.setErrors({});

        const schema = Yup.object().shape({
          title: Yup.string()
            .max(100, 'Assunto muito extenso.')
            .required('Campo obrigatório.'),
          comment: Yup.string()
            .max(30, 'Senha muito extensa.')
            .required('Campo obrigatório.'),
        });

        await schema.validate(data, { abortEarly: false });

        if (stars === 0) {
          addNotices({
            type: 'errors',
            messages: ['Informe sua nota para o produto.'],
          });

          throw new Error('Informe sua nota para o produto.');
        }

        dispatch(
          addProductReview({
            productId: product.id,
            comment: data.comment,
            title: data.title,
            evaluation: stars,
            recommends: true,
          }),
        );

        addNotices({
          type: 'success',
          messages: ['Avaliação enviada com sucesso!'],
        });

        setShowModalRatingProduct(false);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRatingProduct.current?.setErrors(errors);
        }
      }
    },
    [dispatch, addProductReview, stars],
  );

  return (
    <Modal
      onClose={() => {
        setStars(0);
        setShowModalRatingProduct(false);
      }}
    >
      <S.Container
        ref={formRatingProduct}
        className="product-rating-modal-content"
        onSubmit={handleRatingProduct}
      >
        <h4>Avaliar produto</h4>

        <span className="evaluate-product-name">{product?.nome}</span>

        <Input type="text" name="title" placeholder="Assunto" />

        <div className="evaluate-product-group">
          <span>Sua classificação</span>

          <Evaluate productEvaluation={stars} setProductEvaluation={setStars} />
        </div>

        <TextArea name="comment" placeholder="Comentário" />

        <button className="modal-button" type="submit">
          Enviar avaliação
        </button>
      </S.Container>
    </Modal>
  );
}
